import Form from "./Form";
import FormStickyHeader from "../../components/FormStickyHeader";

const SupplierCreate: React.FC = () => {
  return (
    <div>
      <FormStickyHeader>New Supplier</FormStickyHeader>
      <Form />
    </div>
  );
};

export default SupplierCreate;
